// extracted by mini-css-extract-plugin
export default {"author":"D5SGAIGj","meta":"cS39CkSL","avatar":"Q_E8QC0o","mobile":"mobile"};